// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"117b4c88","262":"e56ed961","974":"fdc2bfb8"}[chunkId] + ".chunk.js";
};